var $76a414311c9ecad7$exports = {};
$76a414311c9ecad7$exports = {
    "endTime": `Hora de finalizaci\xf3n`,
    "startTime": `Hora de inicio`,
    "time": `Hora`
};


export {$76a414311c9ecad7$exports as default};
//# sourceMappingURL=es-ES.module.js.map
